import React from "react";

const HeaderNavigation = () => {
  return <div>HeaderNavigation</div>;
};

export default HeaderNavigation;
